import React, { FunctionComponent, useCallback } from 'react';
import ContactFormCreateContainer from './contact-form-create-container';
import { ContactFormModalProps } from './contact-form-modal';
import Client from 'client';
import gql from 'graphql-tag';
import { useCreateContact } from 'generated/api-client/@tanstack/react-query.gen';
import { useMutation } from '@tanstack/react-query';
import { CreateContactRequest } from 'generated/api-client';

type ContactFormCreateRepository = ContactFormModalProps & {
  onContactCreated?: (contactId: number) => void;
};

const ContactFormCreateRepository: FunctionComponent<
  ContactFormCreateRepository
> = ({ onContactCreated, ...rest }) => {
  const isExistingContact = useCallback(
    async (
      givenName: string,
      familyName: string,
      email: string,
      phoneNumber: string,
    ): Promise<boolean> => {
      const result = await Client.query({
        query: gql`
          query getContact(
            $givenName: String!
            $familyName: String!
            $email: String!
            $phoneNumber: String!
          ) {
            proPerson(
              where: {
                _and: [
                  { givenName: { _ilike: $givenName } }
                  { familyName: { _ilike: $familyName } }
                  {
                    _or: [
                      { email: { _ilike: $email } }
                      { telephone: { _ilike: $phoneNumber } }
                    ]
                  }
                ]
              }
            ) {
              id
            }
          }
        `,
        variables: {
          givenName: givenName.trim(),
          familyName: familyName.trim(),
          email: email.trim(),
          phoneNumber: phoneNumber.trim(),
        },
        fetchPolicy: 'network-only',
      });

      return result.data.proPerson.length > 0;
    },
    [],
  );

  const { mutateAsync: createContactMutation } = useCreateContact({
    onSuccess: (data) => {
      onContactCreated?.(data.id);
    },
  });

  return (
    <ContactFormCreateContainer
      isExistingContact={isExistingContact}
      createContact={createContactMutation}
      {...rest}
    />
  );
};

export default ContactFormCreateRepository;
